module.exports = __webpack_public_path__ + "WorkSans-Regular.02a6834d53679f5a0c80.woff";


//////////////////
// WEBPACK FOOTER
// ./src/assets/webfonts/sans/WorkSans-Regular.woff
// module id = ./src/assets/webfonts/sans/WorkSans-Regular.woff
// module chunks = styles